import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { PriceResultsItemCTA } from './components/PriceResultsItemCTA/PriceResultsItemCTA';
import { PriceResultsItemDetails } from './components/PriceResultsItemDetails/PriceResultsItemDetails';
import { PriceResultsItemImage } from './components/PriceResultsItemImage/PriceResultsItemImage';
import { PriceResultsItemTitle } from './components/PriceResultsItemTitle/PriceResultsItemTitle';

type Props = {
    itemId: number;
};

export const PriceResultsItem = ({ itemId }: Props) => {
    return (
        <div
            className={cn(
                'grid grid-cols-[282px_1fr] grid-rows-[min-content_1fr_min-content] gap-x-md gap-y-sm border-b border-border-secondary pb-lg',
                // TABLET
                'smMax:grid-cols-[282px_1fr] smMax:gap-sm smMax:px-0',
                // MOBILE
                'xsMax:grid-cols-[1fr] xsMax:grid-rows-[248px_min-content_min-content_min-content]'
            )}
        >
            <PriceResultsItemImage
                className="col-start-1 col-end-2 row-start-1 row-end-4 xsMax:col-end-3 xsMax:row-end-2 xsMax:flex xsMax:justify-center xsMax:px-sm"
                itemId={itemId}
            />
            <PriceResultsItemTitle
                className="col-start-2 col-end-3 row-start-1 row-end-2 h-min xsMax:col-start-1 xsMax:col-end-3 xsMax:row-start-2 xsMax:row-end-3 xsMax:px-sm"
                itemId={itemId}
            />
            <PriceResultsItemDetails className="col-start-2 col-end-3 row-start-2 row-end-3 xsMax:col-start-1 xsMax:row-start-3 xsMax:row-end-4" />
            <PriceResultsItemCTA
                className="col-start-2 col-end-3 row-start-3 row-end-4 xsMax:col-start-1 xsMax:col-end-3 xsMax:row-start-4 xsMax:row-end-5 xsMax:px-sm"
                itemId={itemId}
            />
        </div>
    );
};
